/**
 * Convert product shelf/package price to kr/kg for Inköpspris/kg autofill.
 * Uses calculated_average_price (+ unit when present) and product size.
 * Returns '' when conversion is not possible.
 *
 * Price unit ids (products.calculated_average_price_unit_id):
 * 1 = st (package), 2 = kg, 6 = l
 */
export function purchasePricePerKgFromProduct(product) {
  if (!product) return '';

  const price = parseFloat(product.calculated_average_price);
  if (Number.isNaN(price) || price < 0) return '';

  const priceUnitId = product.calculated_average_price_unit_id != null
    ? Number(product.calculated_average_price_unit_id)
    : null;

  // Already jämförpris / per kg (or kr/l ≈ kr/kg)
  if (priceUnitId === 2 || priceUnitId === 6) {
    return Math.round(price * 100) / 100;
  }

  const size = parseFloat(product.size);
  if (Number.isNaN(size) || size <= 0) return '';

  const unit = String(product.default_unit_abbr || '').toLowerCase().trim();
  let massKg = null;

  switch (unit) {
    case 'kg':
      massKg = size;
      break;
    case 'g':
      massKg = size / 1000;
      break;
    case 'mg':
      massKg = size / 1_000_000;
      break;
    case 'l':
    case 'liter':
      // Assume density ≈ 1 for liquids
      massKg = size;
      break;
    case 'ml':
      massKg = size / 1000;
      break;
    case 'cl':
      massKg = size / 100;
      break;
    case 'dl':
      massKg = size / 10;
      break;
    default:
      return '';
  }

  if (!massKg || massKg <= 0) return '';

  return Math.round((price / massKg) * 100) / 100;
}
